import formatImgixUrl from "@/utils/image/formatImgixUrl";

import handleImageEncode from "./handleImageEncode";

export default (url: string, params: Record<string, string> = {}) =>
  `${handleImageEncode(formatImgixUrl(url))}?${new URLSearchParams({
    auto: "compress,format",
    ...params,
  })}`;
